// extracted by mini-css-extract-plugin
export default {"card":"item_card_card__9G5xn","image":"item_card_image__8bCpW","details":"item_card_details__UZpj2","packing":"item_card_packing__kWlQp"};